import styled from "styled-components";
import { useEffect } from "react";
import { SecondaryButton } from "../components/Button";
import { Spacer } from "../editor/EditorHelpers";
import { useNavigate, useParams } from "react-router-dom";
import { KEY_OWN_CID, KEY_TOKEN } from "./challengeModel";
import { ChallengeButtonBar } from "./ChallengeHelpers";
import { useTranslation } from "react-i18next";


function setThemeColor(color) {
  let themeColor = document.querySelector('meta[name="theme-color"]');
  if (!themeColor) {
    themeColor = document.createElement('meta');
    themeColor["name"] = 'theme-color';
    document.head.appendChild(themeColor);
  }
  themeColor.setAttribute('content', color);
}

export default function RecoverChallenge() {
  const { t } = useTranslation();
  const { token } = useParams();
  const navigate = useNavigate();
  
  useEffect(() => {
    console.log("recover challenge token:", token);
    if (!token) {
      return;
    }
    const formData: Record<string, string> = {
      token
    };
    fetch('/api/recover_challenge.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: new URLSearchParams(formData)
    })
      .then(response => response.json())
      .then(data => {
        if (data.token) {
          console.log("recover_or_create_challenge.php token:", data.token, data.cid);
          localStorage.setItem(KEY_OWN_CID, data.cid);
          localStorage.setItem(KEY_TOKEN, data.token);
          navigate("/challenge/" + data.cid);
        } else {
          console.log("recover_or_create_challenge.php error:", data.error);
        }
      })
      .catch(error => console.error('Error:', error));

  }, [token])

  useEffect(() => {
    const rootElement = document.getElementById('root');    
    rootElement.classList.add("challenge-green");
    const isDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
    if (isDark) {
      setThemeColor('hsl(120, 40%, 18%)');
    } else {
      setThemeColor('hsl(120, 40%, 18%)');
    }
    return () => {
      rootElement.classList.remove("challenge-green");
      if (isDark) {
        setThemeColor('#002266');
      } else {
        setThemeColor('#003399');
      }
      }
  }, []);

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <div className="generic-page" >
      <div className="narrow-content" style={{
        //fontFamily: "'Times New Roman', Times, serif"
      }}>
        {/*<h1>{t('buy-european-challenge.title')}</h1>*/}
        {!token && <div>
          <Header>{t('challenge.recover.check-your-email.header')}</Header>
          <Subheader>
            {t('challenge.recover.check-your-email.message')}
          </Subheader>
          <ChallengeButtonBar style={{maxWidth: '450px'}}>
            <Spacer style={{flexGrow: 1}} />
            <SecondaryButton type='button' onClick={handleBack}>{t('back.button')}</SecondaryButton>
          </ChallengeButtonBar>
        </div>}
      </div>
    </div>
  )
}

const Header = styled.h1`

`

const Subheader = styled.div`
  font-weight: 400;
  font-size: 1.15rem;
  max-width: 450px;
  margin-left: auto;
  margin-right: auto;
  text-align: left;
  margin-bottom: 1.5rem;
`
